<script setup>
import { ref } from 'vue';
import { useConfigStore } from './store/config';
import { useMenuStore } from './store/menu';

const configStore = useConfigStore();
const menuStore = useMenuStore();
const loading = ref(true);
setTimeout(async () => {
  try {
    await configStore.initConfig();
    await menuStore.initMenus();
  } catch (error) {}
  loading.value = false;
}, 1000);
</script>
<template>
  <div class="project-root-node" :style="configStore.rootStyle" v-loading="loading">
    <router-view />
  </div>
</template>

<style lang="scss">
body {
  min-width: 1280px;
}

.project-root-node {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: var(--color-bg-light);
  font-size: var(--font-size-medium);
  color: var(--color-text);
}
.watermark {
  position: fixed;
  bottom: 5px;
  pointer-events: none;
  color: #6668;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}
.search-card .el-form-item {
  margin-bottom: 0;
}

.dialog-footer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
